import { Flower2 } from "lucide-react";

export function HasfarmLogo({ className = "", light = false }) {
  return (
    <div className={`flex items-center gap-2.5 ${className}`} data-testid="hasfarm-logo">
      <div className="grid h-10 w-10 place-items-center rounded-2xl bg-[#EBBAD1] text-[#28282E] shadow-sm">
        <Flower2 className="h-5 w-5" strokeWidth={2.4} />
      </div>
      <div className="leading-none">
        <span className={`block font-serif text-xl font-extrabold tracking-tight ${light ? "text-white" : "text-[#28282E]"}`}>
          Hasfarm
        </span>
        <span className={`mt-0.5 block text-[10px] font-semibold uppercase tracking-[0.2em] ${light ? "text-[#EBBAD1]" : "text-[#D46117]"}`}>
          Orders Portal
        </span>
      </div>
    </div>
  );
}
